import React, { useState } from "react";
import { Box, Chip, Tabs, Tab, Typography } from "@mui/material";
import AirSystem from "./checklist/air-system";
import FuelSystem from "./checklist/fuel-system";
import LubricationSystem from "./checklist/lubrication-system";
import CoolantCondition from "./checklist/coolant-condition";
import ElectricalSystem from "./checklist/electrical-system";
import { CATEGORY_TABS_LIST } from "./checklist/helper";

const InfantChecklist = ({ details, setDetails }) => {
  const [activeTab, setActiveTab] = useState(CATEGORY_TABS_LIST[0].value);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Infant checklist
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: 2,
        }}
      >
        {CATEGORY_TABS_LIST.map((option) => (
          <Chip
            key={option.value}
            label={option.label}
            variant={activeTab === option.value ? "filled" : "outlined"}
            color={activeTab === option.value ? "primary" : "default"}
            onClick={() => setActiveTab(option.value)}
            sx={{ cursor: "pointer" }}
          />
        ))}
      </Box>

      <Box>
        {activeTab === CATEGORY_TABS_LIST[0].value && (
          <AirSystem
            checklistDetails={details}
            setChecklistDetails={setDetails}
          />
        )}
        {activeTab === CATEGORY_TABS_LIST[1].value && (
          <FuelSystem
            checklistDetails={details}
            setChecklistDetails={setDetails}
          />
        )}
        {activeTab === CATEGORY_TABS_LIST[2].value && (
          <LubricationSystem
            checklistDetails={details}
            setChecklistDetails={setDetails}
          />
        )}
        {activeTab === CATEGORY_TABS_LIST[3].value && (
          <CoolantCondition
            checklistDetails={details}
            setChecklistDetails={setDetails}
          />
        )}
        {activeTab === CATEGORY_TABS_LIST[4].value && (
          <ElectricalSystem
            checklistDetails={details}
            setChecklistDetails={setDetails}
          />
        )}
      </Box>
    </Box>
  );
};

export default InfantChecklist;
